import React from 'react';
export const DatenschutzPage: React.FC = () => {
  return <div className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-256">
      <div className="max-w-4xl mx-auto" data-id="element-257">
        <h1 className="text-4xl text-orange-500 font-light mb-12" data-id="element-258">
          Datenschutzerklärung
        </h1>

        <div className="space-y-8 text-gray-700 leading-relaxed" data-id="element-259">
          {/* Einleitung */}
          <div className="space-y-4" data-id="element-260">
            <p data-id="element-261">
              Personenbezogene Daten (nachfolgend zumeist nur „Daten" genannt)
              werden von uns nur im Rahmen der Erforderlichkeit sowie zum Zwecke
              der Bereitstellung eines funktionsfähigen und nutzerfreundlichen
              Internetauftritts, inklusive seiner Inhalte und der dort
              angebotenen Leistungen, verarbeitet.
            </p>

            <p data-id="element-262">
              Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der
              Datenschutz-Grundverordnung (nachfolgend nur „DSGVO" genannt),
              gilt als „Verarbeitung" jeder mit oder ohne Hilfe automatisierter
              Verfahren ausgeführter Vorgang oder jede solche Vorgangsreihe im
              Zusammenhang mit personenbezogenen Daten, wie das Erheben, die
              Organisation, das Ordnen, die Speicherung, die Anpassung oder
              Veränderung, das Auslesen, das Abfragen, die Verwendung, die
              Offenlegung durch Übermittlung, Verbreitung oder eine andere Form
              der Bereitstellung, den Abgleich oder die Verknüpfung, die
              Einschränkung, das Löschen oder die Vernichtung.
            </p>

            <p data-id="element-263">
              Mit der nachfolgenden Datenschutzerklärung informieren wir Sie
              insbesondere über Art, Umfang, Zweck, Dauer und Rechtsgrundlage
              der Verarbeitung personenbezogener Daten, soweit wir entweder
              allein oder gemeinsam mit anderen über die Zwecke und Mittel der
              Verarbeitung entscheiden. Zudem informieren wir Sie nachfolgend
              über die von uns zu Optimierungszwecken sowie zur Steigerung der
              Nutzungsqualität eingesetzten Fremdkomponenten, soweit hierdurch
              Dritte Daten in wiederum eigener Verantwortung verarbeiten.
            </p>

            <p data-id="element-264">Unsere Datenschutzerklärung ist wie folgt gegliedert:</p>
            <p data-id="element-265">I. Informationen über uns als Verantwortliche</p>
            <p data-id="element-266">II. Rechte der Nutzer und Betroffenen</p>
            <p data-id="element-267">III. Informationen zur Datenverarbeitung</p>
          </div>

          {/* I. Informationen über uns als Verantwortliche */}
          <div className="pt-8" data-id="element-268">
            <h2 className="text-3xl text-orange-500 font-light mb-6" data-id="element-269">
              I. Informationen über uns als Verantwortliche
            </h2>

            <p className="mb-4" data-id="element-270">
              Verantwortlicher Anbieter dieses Internetauftritts im
              datenschutzrechtlichen Sinne ist:
            </p>

            <div className="mb-4" data-id="element-271">
              <p data-id="element-272">Wandelwert</p>
              <p data-id="element-273">Eva Sophie Schifferer</p>
              <p data-id="element-274">Rohrbachstraße 35</p>
              <p data-id="element-275">60389 Frankfurt am Main</p>
              <p data-id="element-276">Telefon: +49 (171) 80 80 455</p>
              <p data-id="element-277">
                E-Mail:{' '}
                <a href="mailto:schifferer@wandelwert.com" className="text-orange-500 hover:underline" data-id="element-278">
                  schifferer@wandelwert.com
                </a>
              </p>
            </div>
          </div>

          {/* II. Rechte der Nutzer und Betroffenen */}
          <div className="pt-8" data-id="element-279">
            <h2 className="text-3xl text-orange-500 font-light mb-6" data-id="element-280">
              II. Rechte der Nutzer und Betroffenen
            </h2>

            <p className="mb-4" data-id="element-281">
              Mit Blick auf die nachfolgend noch näher beschriebene
              Datenverarbeitung haben die Nutzer und Betroffenen das Recht
            </p>

            <ul className="space-y-3 mb-6" data-id="element-282">
              <li className="flex items-start" data-id="element-283">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-284"></span>
                <span data-id="element-285">
                  auf Bestätigung, ob sie betreffende Daten verarbeitet werden,
                  auf Auskunft über die verarbeiteten Daten, auf weitere
                  Informationen über die Datenverarbeitung sowie auf Kopien der
                  Daten (vgl. auch Art. 15 DSGVO);
                </span>
              </li>
              <li className="flex items-start" data-id="element-286">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-287"></span>
                <span data-id="element-288">
                  auf Berichtigung oder Vervollständigung unrichtiger bzw.
                  unvollständiger Daten (vgl. auch Art. 16 DSGVO);
                </span>
              </li>
              <li className="flex items-start" data-id="element-289">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-290"></span>
                <span data-id="element-291">
                  auf unverzügliche Löschung der sie betreffenden Daten (vgl.
                  auch Art. 17 DSGVO), oder, alternativ, soweit eine weitere
                  Verarbeitung gemäß Art. 17 Abs. 3 DSGVO erforderlich ist, auf
                  Einschränkung der Verarbeitung nach Maßgabe von Art. 18 DSGVO;
                </span>
              </li>
              <li className="flex items-start" data-id="element-292">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-293"></span>
                <span data-id="element-294">
                  auf Erhalt der sie betreffenden und von ihnen bereitgestellten
                  Daten und auf Übermittlung dieser Daten an andere
                  Anbieter/Verantwortliche (vgl. auch Art. 20 DSGVO);
                </span>
              </li>
              <li className="flex items-start" data-id="element-295">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-296"></span>
                <span data-id="element-297">
                  auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie der
                  Ansicht sind, dass die sie betreffenden Daten durch den
                  Anbieter unter Verstoß gegen datenschutzrechtliche
                  Bestimmungen verarbeitet werden (vgl. auch Art. 77 DSGVO).
                </span>
              </li>
            </ul>

            <p className="mb-4" data-id="element-298">
              Darüber hinaus ist der Anbieter dazu verpflichtet, alle Empfänger,
              denen gegenüber Daten durch den Anbieter offengelegt worden sind,
              über jedwede Berichtigung oder Löschung von Daten oder die
              Einschränkung der Verarbeitung, die aufgrund der Artikel 16, 17
              Abs. 1, 18 DSGVO erfolgt, zu unterrichten. Diese Verpflichtung
              besteht jedoch nicht, soweit diese Mitteilung unmöglich oder mit
              einem unverhältnismäßigen Aufwand verbunden ist. Unbeschadet
              dessen hat der Nutzer ein Recht auf Auskunft über diese Empfänger.
            </p>

            <p data-id="element-299">
              Ebenfalls haben die Nutzer und Betroffenen nach Art. 21 DSGVO das
              Recht auf Widerspruch gegen die künftige Verarbeitung der sie
              betreffenden Daten, sofern die Daten durch den Anbieter nach
              Maßgabe von Art. 6 Abs. 1 lit. f) DSGVO verarbeitet werden.
              Insbesondere ist ein Widerspruch gegen die Datenverarbeitung zum
              Zwecke der Direktwerbung statthaft.
            </p>
          </div>

          {/* III. Informationen zur Datenverarbeitung */}
          <div className="pt-8" data-id="element-300">
            <h2 className="text-3xl text-orange-500 font-light mb-6" data-id="element-301">
              III. Informationen zur Datenverarbeitung
            </h2>

            <p className="mb-8" data-id="element-302">
              Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten
              werden gelöscht oder gesperrt, sobald der Zweck der Speicherung
              entfällt, der Löschung der Daten keine gesetzlichen
              Aufbewahrungspflichten entgegenstehen und nachfolgend keine
              anderslautenden Angaben zu einzelnen Verarbeitungsverfahren
              gemacht werden.
            </p>

            {/* Kontaktanfragen */}
            <div className="mb-8" data-id="element-303">
              <h3 className="text-2xl text-orange-500 font-light mb-4" data-id="element-304">
                Kontaktanfragen / Kontaktmöglichkeit
              </h3>

              <p className="mb-4" data-id="element-305">
                Sofern Sie per Kontaktformular oder E-Mail mit uns in Kontakt
                treten, werden die dabei von Ihnen angegebenen Daten zur
                Bearbeitung Ihrer Anfrage genutzt. Die Angabe der Daten ist zur
                Bearbeitung und Beantwortung Ihre Anfrage erforderlich – ohne
                deren Bereitstellung können wir Ihre Anfrage nicht oder
                allenfalls eingeschränkt beantworten.
              </p>

              <p className="mb-4" data-id="element-306">
                Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 lit. b)
                DSGVO.
              </p>

              <p data-id="element-307">
                Ihre Daten werden gelöscht, sofern Ihre Anfrage abschließend
                beantwortet worden ist und der Löschung keine gesetzlichen
                Aufbewahrungspflichten entgegenstehen, wie bspw. bei einer sich
                etwaig anschließenden Vertragsabwicklung.
              </p>
            </div>

            {/* LinkedIn */}
            <div data-id="element-308">
              <h3 className="text-2xl text-orange-500 font-light mb-4" data-id="element-309">
                LinkedIn
              </h3>

              <p className="mb-4" data-id="element-310">
                Wir unterhalten bei LinkedIn eine Onlinepräsenz um unser
                Unternehmen sowie unsere Leistungen zu präsentieren und mit
                Kunden/Interessenten zu kommunizieren. LinkedIn ist ein Service
                der LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton
                Place, Dublin 2, Irland, ein Tochterunternehmen der LinkedIn
                Corporation, 1000 W. Maude Avenue, Sunnyvale, CA 94085, USA.
              </p>

              <p className="mb-4" data-id="element-311">
                Insofern weisen wir darauf hin, dass die Möglichkeit besteht,
                dass Daten der Nutzer außerhalb der Europäischen Union,
                insbesondere in den USA, verarbeitet werden. Hierdurch können
                gesteigerte Risiken für die Nutzer insofern bestehen, als dass
                z.B. der spätere Zugriff auf die Nutzerdaten erschwert werden
                kann. Auch haben wir keinen Zugriff auf diese Nutzerdaten. Die
                Zugriffsmöglichkeit liegt ausschließlich bei LinkedIn.
              </p>

              <p data-id="element-312">
                Die Datenschutzhinweise von LinkedIn finden Sie unter{' '}
                <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline" data-id="element-313">
                  https://www.linkedin.com/legal/privacy-policy
                </a>
              </p>
            </div>
          </div>

          {/* Muster-Datenschutzerklärung */}
          <div className="pt-8 text-sm" data-id="element-314">
            <p data-id="element-315">
              <a href="#" className="text-orange-500 hover:underline" data-id="element-316">
                Muster-Datenschutzerklärung
              </a>{' '}
              der{' '}
              <a href="#" className="text-orange-500 hover:underline" data-id="element-317">
                Anwaltskanzlei Weiß & Partner
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>;
};